/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Promise_3Inputs */

const en_cap_promise_3 = /** @type {(inputs: Cap_Promise_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A record of every run`)
};

const lv_cap_promise_3 = /** @type {(inputs: Cap_Promise_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katras palaišanas pieraksts`)
};

/**
* | output |
* | --- |
* | "A record of every run" |
*
* @param {Cap_Promise_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_promise_3 = /** @type {((inputs?: Cap_Promise_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Promise_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_promise_3(inputs)
	return en_cap_promise_3(inputs)
});